import CodeTruckList from './pages/ListPage.vue'
import CodeTruckDetail from './pages/FormPage.vue'
import CodeTruckIndex from './pages/IndexPage.vue'

export default [
  {
    path: '/code_truck',
    component: CodeTruckIndex,
    redirect: '/code_truck/list',
    name: 'code_truck',
    children: [
      {
        path: 'list',
        component: CodeTruckList,
        name: 'code_truck.list'
      },
      {
        path: 'create',
        component: CodeTruckDetail,
        name: 'code_truck.create',
        props: {create: true},
      },
      {
        path: 'edit/:id',
        component: CodeTruckDetail,
        name: 'code_truck.edit',
        props: {create: false},
      },
    ],
  },
]
